import Icon from 'veui/components/Icon'

Icon.register({
  sort: {
    paths: [
      {
        d: 'M17 2a2 2 0 012 2v40a2 2 0 01-3.4 1.43L2.6 32.7a2 2 0 012.8-2.86l9.6 9.4V4c0-1.1.9-2 2-2zm12 2a2 2 0 013.4-1.43l13 12.73a2 2 0 01-2.8 2.86L33 8.76V44a2 2 0 11-4 0z'
      }
    ],
    width: '48',
    height: '48'
  }
})
